export default __webpack_public_path__ + "25c23d7a1b7e172fb1294020166b6268.svg";